var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMailClosed = function SvgMailClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39999 8.00002C1.39999 7.11637 2.11634 6.40002 2.99999 6.40002H21C21.8836 6.40002 22.6 7.11637 22.6 8.00002V20C22.6 20.8837 21.8836 21.6 21 21.6H2.99999C2.11634 21.6 1.39999 20.8837 1.39999 20V8.00002ZM2.99999 7.60002C2.77908 7.60002 2.59999 7.77911 2.59999 8.00002V20C2.59999 20.2209 2.77908 20.4 2.99999 20.4H21C21.2209 20.4 21.4 20.2209 21.4 20V8.00002C21.4 7.77911 21.2209 7.60002 21 7.60002H2.99999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69131 8.51447L2.30871 7.48547L12 13.3003L21.6913 7.48547L22.3087 8.51447L12 14.6997L1.69131 8.51447Z"
  })));
};
export default SvgMailClosed;